import React, { Component } from 'react';
import ReactJson from 'react-json-view';
import Modal from '../Modal';

class RemoteConfig extends Component {
    render() {
        const { handleHideModal, configurationParameters } = this.props;

        return (
            <Modal>
                <div className="remote-config-details">
                    <h3>Remote Config Details</h3>
                    <span className="blue-line" />

                    <div className="react-json-div">
                        {configurationParameters && Object.keys(configurationParameters).length ? (
                            <ReactJson
                                src={configurationParameters}
                                enableClipboard={true}
                                name={false}
                                displayDataTypes={false}
                                collapsed={1}
                            />
                        ) : (
                            <span>Remote Config not set for the Application of this Scenario</span>
                        )}
                    </div>

                    <div className="display-at-bottom">
                        <button className="pull-right common-button" onClick={handleHideModal}>
                            Close
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default RemoteConfig;
